<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { tchMarked } from "@common/Common";
    import { AlternativeDetailsDialogViewModel } from "@Alternatives/Alternatives/Components/AlternativeDetailsDialog";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class AlternativeDetailsDialog extends Vue
    {
        get vm(): AlternativeDetailsDialogViewModel { return this.$props.viewModel as AlternativeDetailsDialogViewModel; }

        get opened(): boolean { return this.vm?.opened ?? false; }
        get name(): string { return this.vm.name; }
        get description(): string | null { return this.vm.description; }
        get descriptionHtml(): string | null { return tchMarked(this.description); }
        get detailsUrl(): string | null { return this.vm.detailsUrl; }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{name}}​</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <p v-if="!description" class="text-muted font-italic lead">No description provided</p>
                        <div v-html="descriptionHtml"></div>
                    </div>

                    <div class="modal-footer">
                        <a v-if="detailsUrl" v-sanitizedHref="detailsUrl" target="_blank" class="btn btn-success">Details</a>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

</style>